module.exports = __webpack_public_path__ + "static/media/size7.bd7657be.svg";